// The importing stage component statically displays some possible metadata taken from one dataset
export default function ImportingStage() {
  return (
    <div style={{ overflowY: "auto", height: "100%", contain: "strict", fontSize: "20px"}}>

      <p><i className="fa fa-thermometer-full main-color"></i> Temperature in each house was collected by specialised thermometers every 30 minutes</p>
      <p><i className="fa fa-calendar main-color"></i> The data was gathered over the summer of 2022</p>
      <p>The data is categorised by: <br></br>
          <i className="fa fa-home main-color"></i> Housing type <br></br>
          <i className="fa-solid fa-fan main-color"></i> Ventilation method</p>
      <p>
        You can explore stages of the data visualisation pipeline:<br></br>
        <i className="fa fa-file-text main-color"></i> Data collection<br></br>
        <i className="fa fa-filter main-color"></i> Filtering<br></br>
        <i className="fa fa-calendar main-color"></i> Mapping <br></br>
        <i className="fa fa-line-chart main-color"></i> Rendering 
      </p>
      <p>
        How can this lead to <i className="fa fa-search main-color"></i> Insight?
      </p>
    </div>
  );
}